import { useAuth0 } from '@auth0/auth0-react';

export const useToken = () => {
  const { getAccessTokenSilently } = useAuth0();
  const token = getAccessTokenSilently();
  return token;
};
